import { ObjectId } from "mongodb";

global.oid = (_id, generate) => {
    if (generate) return new ObjectId();
    if (ObjectId.isValid(_id)) {
        if (_id instanceof ObjectId) {
            return _id; // already an ObjectId
        }

        if (typeof _id === 'string') {
            return new ObjectId(_id); // convert valid string to ObjectId
        }
    }
    return null;
    throw new Error(`[oid] Invalid parameters: ${_id} | Generate: ${generate}`);
}

global.guid = () => {
    return oid(null, true);
}